const money = new Intl.NumberFormat("en-ZA", {
  style: "currency",
  currency: "ZAR",
  maximumFractionDigits: 0
});

function initVelourFilters() {
  const grid = document.querySelector("[data-velour-filter-grid]");
  const form = document.querySelector("[data-velour-filters]");
  if (!grid || !form) return;

  const apply = () => {
    const query = String(form.querySelector("[name='q']")?.value || "").toLowerCase();
    const category = form.querySelector("[name='category']")?.value || "all";
    const gender = form.querySelector("[name='gender']")?.value || "all";
    const type = form.querySelector("[name='type']")?.value || "all";
    const price = form.querySelector("[name='price']")?.value || "all";

    grid.querySelectorAll("[data-product-card]").forEach((card) => {
      const cardPrice = Number(card.dataset.price || 0);
      const searchable = `${card.dataset.title || ""} ${card.dataset.copy || ""}`.toLowerCase();
      const withinPrice =
        price === "all" ||
        (price === "under-750" && cardPrice < 750) ||
        (price === "750-1500" && cardPrice >= 750 && cardPrice <= 1500) ||
        (price === "1500-plus" && cardPrice > 1500);
      const matches =
        (!query || searchable.includes(query)) &&
        (category === "all" || card.dataset.category === category) &&
        (gender === "all" || card.dataset.gender === gender) &&
        (type === "all" || card.dataset.type === type) &&
        withinPrice;
      card.hidden = !matches;
    });
  };

  form.addEventListener("input", apply);
  form.addEventListener("change", apply);
}

function initVelourCart() {
  const drawer = document.querySelector("[data-velour-cart]");
  if (!drawer) return;

  const count = document.querySelector("[data-velour-cart-count]");
  const list = drawer.querySelector("[data-cart-items]");
  const total = drawer.querySelector("[data-cart-total]");

  const fetchCart = async () => {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Unable to fetch cart");
    return response.json();
  };

  const render = (cart) => {
    if (count) count.textContent = String(cart.item_count || 0);
    list.innerHTML = cart.items.length
      ? cart.items.map((item) => `
        <div class="velour-cart-item" data-cart-line="${item.key}">
          <a class="velour-cart-item-image" href="${item.url}">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ""}
          </a>
          <div class="velour-cart-item-body">
            <div class="velour-cart-item-top">
              <div>
                <strong>${item.product_title}</strong>
                ${item.variant_title ? `<span>${item.variant_title}</span>` : ""}
              </div>
              <p>${money.format((item.final_line_price || item.line_price || 0) / 100)}</p>
            </div>
            <div class="velour-cart-item-actions">
              <div class="velour-qty-control" aria-label="Quantity controls">
                <button type="button" data-cart-quantity="${item.quantity - 1}" data-cart-key="${item.key}" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-quantity="${item.quantity + 1}" data-cart-key="${item.key}" aria-label="Increase quantity">+</button>
              </div>
              <button class="velour-cart-remove" type="button" data-cart-remove="${item.key}" aria-label="Remove ${item.product_title}">×</button>
            </div>
          </div>
        </div>
      `).join("")
      : "<p>Your ritual is waiting. Add a fragrance, display or bundle to begin.</p>";
    total.textContent = money.format((cart.total_price || 0) / 100);
  };

  const refresh = async () => {
    try {
      render(await fetchCart());
    } catch (error) {
      console.warn(error);
    }
  };

  const changeLine = async (lineKey, quantity) => {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id: lineKey, quantity: Math.max(0, Number(quantity)) })
    });
    if (!response.ok) throw new Error("Unable to update cart");
    render(await response.json());
  };

  const addVariant = async (variantId) => {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
    if (!response.ok) throw new Error("Unable to add item to cart");
    await refresh();
  };

  document.addEventListener("click", async (event) => {
    const add = event.target.closest("[data-quick-add]");
    if (add) {
      add.disabled = true;
      try {
        await addVariant(add.dataset.quickAdd);
        drawer.classList.add("is-open");
      } catch (error) {
        console.warn(error);
      } finally {
        add.disabled = false;
      }
    }

    const quantity = event.target.closest("[data-cart-quantity]");
    if (quantity) {
      quantity.disabled = true;
      try {
        await changeLine(quantity.dataset.cartKey, quantity.dataset.cartQuantity);
      } catch (error) {
        console.warn(error);
      } finally {
        quantity.disabled = false;
      }
    }

    const remove = event.target.closest("[data-cart-remove]");
    if (remove) {
      remove.disabled = true;
      try {
        await changeLine(remove.dataset.cartRemove, 0);
      } catch (error) {
        console.warn(error);
      } finally {
        remove.disabled = false;
      }
    }

    const buyNow = event.target.closest("[data-buy-now]");
    if (buyNow) {
      buyNow.disabled = true;
      try {
        await addVariant(buyNow.dataset.buyNow);
        window.location.href = "/checkout";
      } catch (error) {
        console.warn(error);
        buyNow.disabled = false;
      }
    }

    if (event.target.closest("[data-cart-open]")) drawer.classList.add("is-open");
    if (event.target.closest("[data-cart-close]")) drawer.classList.remove("is-open");
  });

  refresh();
}

function initVelourMotion() {
  const reveals = document.querySelectorAll(".velour-reveal");
  if (!("IntersectionObserver" in window)) {
    reveals.forEach((el) => el.classList.add("is-visible"));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14 });

  reveals.forEach((el) => observer.observe(el));
}

function initVelourMobileMenu() {
  const panel = document.querySelector("[data-velour-mobile-panel]");
  if (!panel) return;

  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-mobile-menu]")) panel.classList.toggle("is-open");
    if (event.target.closest("[data-velour-mobile-panel] a")) panel.classList.remove("is-open");
  });
}

function initVelourVaultPopup() {
  const popup = document.querySelector("[data-velour-vault]");
  if (!popup || typeof popup.showModal !== "function") return;

  const form = popup.querySelector("[data-vault-form]");
  const email = popup.querySelector("[data-vault-email]");
  const status = popup.querySelector("[data-vault-status]");
  const closeButton = popup.querySelector("[data-vault-close]");
  const submitButton = form?.querySelector("button[type='submit']");
  const publicKey = popup.dataset.vaultKlaviyoPublicKey?.trim();
  const listId = popup.dataset.vaultKlaviyoListId?.trim();
  const delaySeconds = Math.max(0, Number(popup.dataset.vaultDelaySeconds || 0));
  const dismissDays = Math.max(1, Number(popup.dataset.vaultDismissDays || 7));
  const storageKey = "velour-vault-dismissed-until";
  const successMessage = popup.dataset.vaultSuccessMessage?.trim() || "Your place in The Vault is reserved. Watch your inbox.";
  let lastFocusedElement = null;

  if (!form || !email || !status || !closeButton || !publicKey || !listId) return;

  const isDismissed = () => Number(window.localStorage.getItem(storageKey) || 0) > Date.now();
  const dismiss = () => {
    const until = Date.now() + dismissDays * 24 * 60 * 60 * 1000;
    window.localStorage.setItem(storageKey, String(until));
  };
  const restoreFocus = () => {
    if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
  };
  const close = () => {
    if (popup.open) popup.close();
    dismiss();
    restoreFocus();
  };
  const open = () => {
    if (isDismissed() || popup.open) return;
    lastFocusedElement = document.activeElement;
    popup.showModal();
    email.focus();
  };

  closeButton.addEventListener("click", close);
  popup.addEventListener("cancel", (event) => {
    event.preventDefault();
    close();
  });
  popup.addEventListener("click", (event) => {
    if (event.target === popup) close();
  });
  popup.addEventListener("keydown", (event) => {
    if (event.key !== "Tab") return;
    const focusable = Array.from(popup.querySelectorAll(
      "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
    )).filter((element) => !element.hidden);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!email.checkValidity()) {
      email.reportValidity();
      return;
    }
    submitButton?.setAttribute("disabled", "disabled");
    status.textContent = "Reserving your place...";
    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicKey)}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", revision: "2024-10-15" },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: { profile: { data: { type: "profile", attributes: { email: email.value.trim() } } } },
            relationships: { list: { data: { type: "list", id: listId } } }
          }
        })
      });
      if (!response.ok) throw new Error(`Klaviyo subscription returned ${response.status}`);
      status.textContent = successMessage;
      dismiss();
      form.reset();
    } catch (error) {
      console.warn("Vault subscription failed", error);
      status.textContent = "We could not reserve your place just yet. Please try again.";
      submitButton?.removeAttribute("disabled");
    }
  });

  window.setTimeout(open, delaySeconds * 1000);
}

function initVelourPresenceProfile() {
  const profile = document.querySelector("[data-presence-profile]");
  if (!profile) return;

  const panels = Array.from(profile.querySelectorAll("[data-presence-step]"));
  const progress = profile.querySelector("[data-presence-progress]");
  const resultPanel = profile.querySelector(".velour-presence-result-panel[data-presence-step]");
  const resultStep = Number(resultPanel?.dataset.presenceStep || panels.length - 1);
  const resultTitle = profile.querySelector("[data-presence-result-title]");
  const resultLine = profile.querySelector("[data-presence-result-line]");
  const resultSummary = profile.querySelector("[data-presence-result-summary]");
  const resultWhy = profile.querySelector("[data-presence-result-why]");
  const resultMood = profile.querySelector("[data-presence-result-mood]");
  const fragranceGrid = profile.querySelector("[data-presence-fragrance-products]");
  const ritualGrid = profile.querySelector("[data-presence-ritual-products]");
  const scores = {
    executive: 0,
    visionary: 0,
    minimalist: 0,
    midnight: 0
  };
  const archetypes = {
    executive: {
      name: "The Executive",
      line: "Structured. Disciplined. Unforgettable.",
      summary: "You move with quiet command. Your presence is built from clean decisions, sharp rituals and objects placed with intention.",
      why: "This profile suits you because it favours fragrances with structure, projection and a composed trail. The impression is authoritative, warm and controlled.",
      mood: "Polished woods, dark amber, aromatic spice and a tailored evening finish.",
      fragrances: [
        { name: "Asad", handle: "asad-noir-woods" },
        { name: "Club de Nuit Intense", handle: "club-intense-oud" },
        { name: "Fakhar Black", handle: "fakhar-black-silk" }
      ],
      ritual: [
        { name: "Scent Display Tray", handle: "scent-display-tray" },
        { name: "Executive Watch Display", handle: "executive-watch-display" },
        { name: "Velour Display Edit", handle: "executive-watch-display" }
      ]
    },
    visionary: {
      name: "The Visionary",
      line: "Creative. Magnetic. Distinctive.",
      summary: "You are led by instinct, atmosphere and original taste. Your presence feels warm, expressive and slightly unexpected.",
      why: "This fragrance direction suits you because it blends texture with memorability: sweetness, amber and spice that feel creative without becoming loud.",
      mood: "Amber warmth, soft spice, resinous sweetness and luminous depth.",
      fragrances: [
        { name: "Vintage Radio", handle: "vintage-radio-amber" },
        { name: "Khamrah", handle: "khamrah" },
        { name: "Ana Abiyedh Rouge", handle: "ana-rouge-musk" }
      ],
      ritual: [
        { name: "Scent Display Tray", handle: "scent-display-tray" },
        { name: "Executive Watch Display", handle: "executive-watch-display" },
        { name: "Velour Display Edit", handle: "executive-watch-display" }
      ]
    },
    minimalist: {
      name: "The Minimalist",
      line: "Calm. Elegant. Intentional.",
      summary: "Your luxury is restraint. You prefer clarity, soft materials, quiet confidence and details that never fight for attention.",
      why: "This profile suits you because it keeps the scent close, elegant and cleanly memorable. It is refined enough for repetition and soft enough for daily ritual.",
      mood: "Creamy musk, pale florals, airy vanilla and smooth modern softness.",
      fragrances: [
        { name: "Noble Blush", handle: "noble-blush" },
        { name: "Bade'e Al Oud Amethyst", handle: "badee-al-oud-sublime-copy" },
        { name: "Ana Rouge Musk", handle: "ana-rouge-musk" }
      ],
      ritual: [
        { name: "Scent Display Tray", handle: "scent-display-tray" },
        { name: "Executive Watch Display", handle: "executive-watch-display" },
        { name: "Velour Display Edit", handle: "executive-watch-display" }
      ]
    },
    midnight: {
      name: "The Midnight Presence",
      line: "Mysterious. Intense. Unforgettable.",
      summary: "You are drawn to shadow, velvet and lasting impact. Your presence is cinematic, private and difficult to erase from memory.",
      why: "This profile suits you because it leans into darker materials: oud, smoke, spice and dense warmth that stay behind after you leave.",
      mood: "Oud, incense, smoked woods, burgundy warmth and nocturnal spice.",
      fragrances: [
        { name: "Oud for Glory", handle: "badee-al-oud-oud-for-glory" },
        { name: "Bade'e Al Oud", handle: "badee-al-oud-reserve" },
        { name: "Club de Nuit Intense", handle: "club-intense-oud" }
      ],
      ritual: [
        { name: "Scent Display Tray", handle: "scent-display-tray" },
        { name: "Executive Watch Display", handle: "executive-watch-display" },
        { name: "Velour Display Edit", handle: "executive-watch-display" }
      ]
    }
  };
  const productCache = new Map();
  let genderSignal = "balanced";
  let step = 0;

  const activateStep = (nextStep) => {
    step = Math.max(0, Math.min(nextStep, panels.length - 1));
    panels.forEach((panel) => {
      panel.classList.toggle("is-active", Number(panel.dataset.presenceStep) === step);
    });
    if (progress) progress.style.width = `${Math.min(100, (step / (panels.length - 1)) * 100)}%`;
  };

  const winningArchetype = () => {
    return Object.entries(scores).sort((a, b) => b[1] - a[1])[0]?.[0] || "executive";
  };

  const applyGenderWeighting = (items) => {
    const weights = {
      masculine: {
        "asad-noir-woods": 3,
        "club-intense-oud": 3,
        "fakhar-black-silk": 2,
        "badee-al-oud-oud-for-glory": 3,
        "badee-al-oud-reserve": 2
      },
      feminine: {
        "ana-rouge-musk": 3,
        "noble-blush": 3,
        "badee-al-oud-sublime-copy": 3,
        "vintage-radio-amber": 1,
        "khamrah": 1
      },
      balanced: {
        "vintage-radio-amber": 2,
        "khamrah": 2,
        "ana-rouge-musk": 2,
        "badee-al-oud-reserve": 1,
        "club-intense-oud": 1
      },
      unspecified: {}
    };
    const selectedWeights = weights[genderSignal] || weights.balanced;
    return [...items].sort((a, b) => (selectedWeights[b.handle] || 0) - (selectedWeights[a.handle] || 0));
  };

  const escapeHtml = (value = "") => String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");

  const fetchProduct = async ({ name, handle }) => {
    if (productCache.has(handle)) return productCache.get(handle);
    try {
      const response = await fetch(`/products/${handle}.js`, { headers: { Accept: "application/json" } });
      if (!response.ok) throw new Error("Product unavailable");
      const product = await response.json();
      const variant = (product.variants || []).find((item) => item.available) || product.variants?.[0];
      const normalized = {
        name,
        available: Boolean(variant?.available),
        title: product.title || name,
        url: product.url || `/products/${handle}`,
        image: product.featured_image || product.images?.[0] || "",
        price: Number(variant?.price || product.price || 0),
        variantId: variant?.id
      };
      productCache.set(handle, normalized);
      return normalized;
    } catch (error) {
      const fallback = { name, available: false, missing: true };
      productCache.set(handle, fallback);
      return fallback;
    }
  };

  const renderProductSkeletons = (grid, items) => {
    if (!grid) return;
    grid.innerHTML = items.map((item) => `
      <article class="velour-presence-product-card is-loading">
        <div class="velour-presence-product-image"></div>
        <div>
          <h3>${escapeHtml(item.name)}</h3>
          <p>Preparing recommendation.</p>
        </div>
      </article>
    `).join("");
  };

  const renderProducts = async (grid, items) => {
    if (!grid) return;
    renderProductSkeletons(grid, items);
    const products = await Promise.all(items.map(fetchProduct));
    grid.innerHTML = products.map((product) => {
      if (product.missing) {
        return `
          <article class="velour-presence-product-card is-missing">
            <div class="velour-presence-product-image">
              ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title || product.name)}" loading="lazy">` : `<span>${escapeHtml(product.name).slice(0, 1)}</span>`}
            </div>
            <div>
              <h3>${escapeHtml(product.title || product.name)}</h3>
              <p>Coming soon to Velour.</p>
            </div>
          </article>
        `;
      }

      return `
        <article class="velour-presence-product-card">
          <a class="velour-presence-product-image" href="${escapeHtml(product.url)}">
            ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : `<span>${escapeHtml(product.title).slice(0, 1)}</span>`}
          </a>
          <div>
            <h3>${escapeHtml(product.title)}</h3>
            <p>${money.format(product.price / 100)}</p>
            <span>${product.available && product.variantId ? "Available" : "Currently unavailable"}</span>
            ${product.available && product.variantId ? `<button type="button" data-quick-add="${product.variantId}">Quick add</button>` : `<button type="button" disabled>Unavailable</button>`}
          </div>
        </article>
      `;
    }).join("");
  };

  const renderResult = (winner) => {
    const result = archetypes[winner] || archetypes.executive;
    if (resultTitle) resultTitle.textContent = result.name;
    if (resultLine) resultLine.textContent = result.line;
    if (resultSummary) resultSummary.textContent = result.summary;
    if (resultWhy) resultWhy.textContent = result.why;
    if (resultMood) resultMood.textContent = result.mood;
    renderProducts(fragranceGrid, applyGenderWeighting(result.fragrances));
    renderProducts(ritualGrid, result.ritual);
  };

  const revealResult = () => {
    renderResult(winningArchetype());
    activateStep(resultStep);
  };

  profile.addEventListener("click", (event) => {
    const gender = event.target.closest("[data-presence-gender]");
    if (gender) {
      genderSignal = gender.dataset.presenceGender || "balanced";
      gender.classList.add("is-selected");
      window.setTimeout(() => activateStep(step + 1), 220);
      return;
    }

    const answer = event.target.closest("[data-presence-answer]");
    if (answer) {
      const archetype = answer.dataset.archetype;
      if (Object.prototype.hasOwnProperty.call(scores, archetype)) scores[archetype] += 1;
      answer.classList.add("is-selected");
      window.setTimeout(() => activateStep(step + 1), 220);
      return;
    }

    if (event.target.closest("[data-presence-next]")) {
      if (step >= resultStep - 1) revealResult();
      else activateStep(step + 1);
      return;
    }

    if (event.target.closest("[data-presence-retake]")) {
      Object.keys(scores).forEach((key) => { scores[key] = 0; });
      genderSignal = "balanced";
      profile.querySelectorAll(".is-selected").forEach((item) => item.classList.remove("is-selected"));
      activateStep(0);
    }
  });

  profile.querySelector("[data-presence-email-form]")?.addEventListener("submit", (event) => {
    event.preventDefault();
    revealResult();
  });

  activateStep(0);
}

document.addEventListener("DOMContentLoaded", () => {
  initVelourFilters();
  initVelourCart();
  initVelourMobileMenu();
  initVelourMotion();
  initVelourVaultPopup();
});
